// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__IYI8O","footer":"ModalError_footer__2NU8I"};